import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_pager" }

import Banner from "@/views/online-report/banner/index1.vue";
import {reactive, ref} from "vue";
import {getItemHandelLogList} from '@/config/request'
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'qrcodeQuery',
  setup(__props) {

const route = useRoute()

const pagination = reactive({
    pageNo: 1,
    pageSize: 10,
    total: 0,
})
const logList = ref([]);
const handleCurrentChange = (index:any) => {
    pagination.pageNo = index
    init();
}
const init = async () => {
    let params = {
        projectcode: route.query.projectcode as any,
    }
    console.log("params:", params)
    await getItemHandelLogList(params).then((res: any) => {
        if(res.code == 200){
            logList.value = res.result;
            logList.value.forEach((item: any) => {
                item.preApasinfo.forEach((preApasinfo: any) => {
                    preApasinfo.isfinish = preApasinfo.isFinish == 1 ? "已完成" : "未完成";
                })
            })
            pagination.total = logList.value.length;
        }
    })
}
const mergeRows = ({row, column, rowIndex, columnIndex }) => {
    // 合并前两列的数据
    if (columnIndex === 1) {
        // 获取当前单元格的值
        const currentValue = row[column.property]
        // 获取上一行相同列的值
        const preRow = logList.value[rowIndex - 1]
        const preValue = preRow ? preRow[column.property] : null
        // 如果当前值和上一行的值相同，则将当前单元格隐藏
        if (currentValue === preValue) {
            return {
                rowspan: 0,
                colspan: 0
            }
        } else {
            // 否则计算当前单元格应该跨越多少行
            let rowspan = 1
            for (let i = rowIndex + 1; i < logList.value.length; i++) {
                const nextRow = logList.value[i]
                const nextValue = nextRow[column.property]
                if (nextValue === currentValue) {
                    rowspan++
                } else {
                    break
                }
            }
            return {
                rowspan,
                colspan: 1
            }
        }
    }
}

init()

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top),
    _createVNode(Banner),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createTextVNode(),
            _createElementVNode("span", null, "企业信用承诺事项办理日志")
          ], -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_el_table, {
              data: logList.value,
              border: "",
              "span-method": mergeRows,
              "highlight-current-row": "",
              "header-cell-style": {color:'#2185f2',textAlign:'center',borderColor:' #CCC',background:'#ebf6fc',height:'60px'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "80",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "一件事名称",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "事项名称",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_table, {
                      data: scope.row.preApasinfo,
                      "show-header": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { prop: "serviceName" })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "是否完成",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_table, {
                      data: scope.row.preApasinfo,
                      "show-header": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { prop: "isfinish" })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_pagination, {
                background: "",
                onCurrentChange: handleCurrentChange,
                layout: "prev, pager, next, total",
                "page-size": pagination.pageSize,
                total: pagination.total
              }, null, 8, ["page-size", "total"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})